<div class="main-container">
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="ngOnInit()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
      <span class="page-title">Ticket Assignment Master</span>
    </div>
  </div>

  <!-- Rendered only with Master Access "update" (blocks direct URL access) -->
  @if (MyActivationsUpdateMasterAccess) {
    <!-- Ticket Master State Assignment List -->
    <div class="component-container">
      <div class="component-header">
        <h6 class="component-title">Ticket Assignment Associated States</h6>
      </div>
      <div class="component-separator"></div>
      <!-- table-responsive -->
      <div class="component-body">
        <table>
          <thead>
            <th>Name</th>
            <th>State</th>
            <th>Action</th>
          </thead>
          <tbody>
            @for (
              assignmentMaster of listOfTicketAssignmentMaster;
              let index = $index;
              track assignmentMaster._id
            ) {
              <tr [matTooltip]="assignmentMaster.description">
                <td>{{ assignmentMaster.displayName }}</td>
                <td>
                  {{ assignmentMaster.stateNames?.join(', ') || '--' }}
                </td>
                <td>
                  @if (MyActivationsUpdateMasterAccess) {
                    <div class="action-buttons">
                      <button
                        class="primary-button edit-button"
                        (click)="openTicketAssignmentPopup(assignmentMaster)"
                      >
                        <mat-icon class="btn-icon">edit</mat-icon>
                      </button>
                    </div>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>

    <!-- Update Ticket Master State Assignment Popup -->
    <div class="custom-container">
      <div class="custom-modal custom-modal-m" id="updateTicketAssignmentPopup">
        <div class="custom-modal-dialog">
          <div class="custom-modal-content">
            <!-- Modal Header -->
            <div class="custom-modal-header">
              <h4 class="custom-modal-title">Update Ticket Assignment</h4>
              <button
                type="button"
                class="custom-close-btn"
                (click)="closeTicketAssignmentPopup()"
              >
                &times;
              </button>
            </div>
            <!-- Modal Body -->
            <form [formGroup]="updateTicketAssignmentForm" novalidate>
              <div class="custom-modal-body">
                <div class="component-container">
                  <div class="component-body">
                    <div class="form-section">
                      <div class="form-group">
                        <label for="Name" class="form-label">Name</label>
                        <mat-form-field appearance="outline">
                          <mat-label>Name</mat-label>
                          <input
                            matInput
                            readonly
                            type="text"
                            [value]="
                              updateTicketAssignmentForm.get('displayName')
                                ?.value
                            "
                          />
                        </mat-form-field>
                      </div>
                      <div class="form-group">
                        <label for="Assigned States" class="form-label"
                          >Assigned States</label
                        >
                        <app-state-wise-user-select-component
                          (remarkChange)="remarkChange($event)"
                          [defaultState]="
                            updateTicketAssignmentForm.get('states')?.value
                          "
                          [allStates]="stateList"
                        ></app-state-wise-user-select-component>
                      </div>
                    </div>
                  </div>

                  <!-- Separator between Body and Footer -->
                  <div class="component-separator"></div>

                  <div class="component-footer">
                    <div class="button-group">
                      <button
                        type="button"
                        class="submit-button"
                        (click)="saveAssignment()"
                      >
                        Submit
                        <mat-icon class="btn-icon">check_circle</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- Separator -->

    <!-- User State Assignment List -->
    <div class="component-container">
      <div class="component-header">
        <h6 class="component-title">User Associated States</h6>
        <div class="component-actions">
          <app-common-component-dropdown-search
            [items]="stateList"
            [placeHolder]="'Select State'"
            (itemSelected)="onStateWiseSelectionChange($event)"
          ></app-common-component-dropdown-search>
          <app-common-search
            matTooltip="Full Name | Email"
            (searchSubmit)="stateWiseUserListOnSearch($event)"
          ></app-common-search>
        </div>
      </div>
      <div class="component-separator"></div>
      <!-- table-responsive -->
      <div class="component-body">
        <table>
          <thead>
            <th>Name</th>
            <th>Email</th>
            <th>Assignment</th>
            <th
              matTooltip="STS_CO_01, STS_CO_02, STS_CO_03, STS_CO_04, STS_CO_05, STS_CO_06"
            >
              Ticket Count IP
            </th>
            <th
              matTooltip="STS_CO_07, STS_CO_08, STS_CO_09, STS_CO_10, STS_CO_11, STS_CO_12, STS_CO_13, STS_CO_14, STS_CO_15, STS_CO_16, STS_CO_28, STS_CO_29, STS_CO_31, STS_CO_32"
            >
              Ticket Count OH
            </th>
            <th>Ticket Count Total</th>
            <th>Action</th>
          </thead>
          @if (allUsers.length !== 0) {
            <tbody>
              @for (
                user of allUsers
                  | paginate
                    : {
                        id: 'user_pagination',
                        itemsPerPage: sizeForStateWiseUserPopup,
                        currentPage: pageForStateWiseUserPopup,
                        totalItems: allUsers.length,
                      };
                track user._id
              ) {
                <tr>
                  <td>{{ user.fullName }}</td>
                  <td>
                    {{ user.customerEmail }}
                  </td>
                  <td>
                    {{ user.parsedAssignments | json }}
                  </td>
                  <td>
                    {{ user.totalIPTickets }}
                  </td>
                  <td>
                    {{ user.totalOHTickets }}
                  </td>
                  <td>
                    {{ user.totalOHTickets + user.totalIPTickets || 0 }}
                  </td>
                  <td>
                    @if (MyActivationsUpdateMasterAccess) {
                      <div class="action-buttons">
                        <button
                          class="primary-button edit-button"
                          (click)="openUserStateAssignmentPopup(user)"
                        >
                          <mat-icon class="btn-icon">edit</mat-icon>
                        </button>
                      </div>
                    }
                  </td>
                </tr>
              }
            </tbody>
          }
          @if (allUsers.length === 0) {
            <tbody>
              <tr>
                <td colspan="12">
                  <img
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>
      <!-- Component Footer Section -->
      <div class="component-footer">
        @if (allUsers.length !== 0) {
          <app-common-component-pagination
            [totalItems]="totalItemsForStateWiseUserPopup"
            [pageSize]="sizeForStateWiseUserPopup"
            [currentPage]="pageForStateWiseUserPopup"
            (pageChange)="onPageChangeForStateWiseUserPopup($event)"
            (sizeChange)="onSizeChangeForStateWiseUserPopup($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </div>

    <!-- Update User State Assignment Popup -->
    <div class="custom-container">
      <div
        class="custom-modal custom-modal-xl"
        id="updateUserStateAssignmentPopup"
      >
        <div class="custom-modal-dialog">
          <div class="custom-modal-content">
            <!-- Modal Header -->
            <div class="custom-modal-header">
              <h4 class="custom-modal-title">
                Update
                {{ updateUserStateAssignmentForm.get('name')?.value }} State
                Assignment
              </h4>
              <button
                type="button"
                class="custom-close-btn"
                (click)="closeUserStateAssignmentPopup()"
              >
                &times;
              </button>
            </div>
            <!-- Modal Body -->
            <form [formGroup]="updateUserStateAssignmentForm" novalidate>
              <div class="custom-modal-body">
                <div class="component-container">
                  <div class="component-body">
                    <div class="form-section">
                      <div class="form-group">
                        <label for="State-Dealer Association" class="form-label"
                          >State-Dealer Association</label
                        >
                        <app-user-assignment-selector
                          [states]="stateList"
                          [assignments]="
                            updateUserStateAssignmentForm.get('assignments')
                              ?.value || []
                          "
                          [dealerMap]="dealerMap"
                          (stateSelected)="loadDealers($event)"
                          (assignmentsChange)="onAssignmentsChange($event)"
                        >
                        </app-user-assignment-selector>
                      </div>
                    </div>
                  </div>

                  <!-- Separator between Body and Footer -->
                  <div class="component-separator"></div>

                  <div class="component-footer">
                    <div class="button-group">
                      <button
                        type="button"
                        class="submit-button"
                        (click)="saveUserStateAssignment()"
                      >
                        Submit
                        <mat-icon class="btn-icon">check_circle</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- Separator -->

    <!-- Update Default User -->
    <div class="component-container">
      <form [formGroup]="updateDefaultTicketAssignToUserForm">
        <div class="component-header">
          <h6 class="component-title">Default Ticket Assigned to</h6>
        </div>
        <div class="component-separator"></div>
        <!-- table-responsive -->
        <div class="component-body">
          <div class="form-section">
            <div class="form-group">
              <label for="defaultTicketAssignedTo" class="form-label"
                >Default Ticket Assigned to</label
              >
              <mat-form-field appearance="outline">
                <mat-label>Select User</mat-label>

                <mat-select formControlName="_id">
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="defaultTicketAssignToUserSelectFilterCtrl"
                      placeholderLabel="Search by name..."
                      noEntriesFoundLabel="No users found"
                    >
                    </ngx-mat-select-search>
                  </mat-option>

                  @for (user of filteredUsers; track user._id) {
                    <mat-option [value]="user._id">
                      {{ user.fullName }}
                    </mat-option>
                  }
                </mat-select>
                @if (
                  updateDefaultTicketAssignToUserForm.controls['_id'].hasError(
                    'required'
                  )
                ) {
                  <mat-error> Please select a user </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </div>
        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>
        <!-- Component Footer Section -->
        <div class="component-footer">
          @if (MyActivationsUpdateMasterAccess) {
            <div class="button-group">
              <button
                type="button"
                (click)="updateDefaultTicketAssignedToUser()"
                class="submit-button"
              >
                Submit <mat-icon class="btn-icon">check_circle</mat-icon>
              </button>
            </div>
          }
        </div>
      </form>
    </div>

    <!-- Separator -->

    <!-- Update FOTA Skip States -->
    <div class="component-container">
      <form [formGroup]="updateFotaNotRequiredStateListForm">
        <div class="component-header">
          <h6 class="component-title">FOTA Skip States</h6>
        </div>
        <div class="component-separator"></div>
        <!-- table-responsive -->
        <div class="component-body">
          <div class="form-section">
            <div class="form-group">
              <label for="fotaSkipStates" class="form-label"
                >FOTA Skip States</label
              >
              <app-state-wise-user-select-component
                (remarkChange)="remarkChangeFotaSkippedStates($event)"
                [defaultState]="
                  updateFotaNotRequiredStateListForm.get('states')?.value || []
                "
                [allStates]="stateList"
              ></app-state-wise-user-select-component>
            </div>
          </div>
        </div>
        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>
        <!-- Component Footer Section -->
        <div class="component-footer">
          @if (MyActivationsUpdateMasterAccess) {
            <div class="button-group">
              <button
                type="button"
                (click)="updateFotaNotRequiredStateList()"
                class="submit-button"
              >
                Submit <mat-icon class="btn-icon">check_circle</mat-icon>
              </button>
            </div>
          }
        </div>
      </form>
    </div>
  }
</div>
